'use client'

import React, { ReactNode, useState } from 'react'

import { PageAboutBoardResponse } from '@/lib/api-connector-strapi-cms/api/page-about/pageAboutApi.types'
import { Markdown } from '@/lib/ui-kit/components/Markdown.component'

import { CardsBoardMembers } from '../components/CardsBoardMembers.component'

export enum TabType {
  executive = 'executive',
  board_members = 'board_members',
}
interface TabItemProps {
  children: ReactNode
  isActive: boolean
  onClick: () => void
}

const TabItem = ({ children, isActive, onClick }: TabItemProps) => {
  return (
    <button
      onClick={onClick}
      className={`pt-s-2 flex w-[50%] flex-col items-center justify-start px-0 pb-2.5 xl:w-auto xl:items-start ${
        isActive && 'border-b-[1px] border-solid border-gray-1000'
      }`}
    >
      <span className="paragraph-s font-medium">{children}</span>
    </button>
  )
}

const BoardTitle = ({ children }: { children?: ReactNode }) => (
  <h3 className="font-inherit heading-xl relative m-0 font-normal">
    {children}
  </h3>
)

type SectionBoardContentProps = PageAboutBoardResponse['data']['pageAbout']

export const SectionBoardContent = ({
  boardCaption,
  boardTitle,
  boardExecutivesMember,
  boardMembers,
}: SectionBoardContentProps) => {
  const [activeTab, setActiveTab] = useState(TabType.executive)

  return (
    <div
      id="board"
      className="font-desktop-paragraph-xxlarge-semibold m-auto flex max-w-[1440px] flex-col items-start justify-start gap-10 bg-gray-200 px-0 py-16 text-mini text-gray-1000 xl:gap-[64px] xl:py-20"
    >
      <div className="box-border flex flex-col gap-10 self-stretch px-6 py-0 xl:gap-[80px] xl:px-10">
        <div className="gap-4 self-stretch xl:gap-[24px]">
          {boardCaption && (
            <div className="caption mb-4 font-medium xl:mb-6">
              {boardCaption}
            </div>
          )}
          {boardTitle && (
            <Markdown
              components={{
                p: BoardTitle,
              }}
            >
              {boardTitle}
            </Markdown>
          )}
        </div>
        <div className="flex flex-row items-end justify-between self-stretch text-center">
          <div className="flex w-[100%] gap-6 xl:w-auto xl:gap-[56px]">
            <TabItem
              isActive={activeTab === TabType.executive}
              onClick={() => setActiveTab(TabType.executive)}
            >
              Executives
            </TabItem>
            <TabItem
              isActive={activeTab === TabType.board_members}
              onClick={() => setActiveTab(TabType.board_members)}
            >
              Board members
            </TabItem>
          </div>
        </div>
      </div>
      <div
        id="sectionEight"
        className="w-full gap-[20px] px-6 py-0 text-lg xl:px-10"
      >
        <div className="flex w-full flex-col items-start justify-start gap-[18px] xl:flex-row">
          <CardsBoardMembers
            boardMembers={boardExecutivesMember}
            activeTab={activeTab}
            tabType={TabType.executive}
          />
          <CardsBoardMembers
            boardMembers={boardMembers}
            activeTab={activeTab}
            tabType={TabType.board_members}
          />
        </div>
      </div>
    </div>
  )
}
